export default "__VITE_ASSET__9d8255d6__"